/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';

import { StyleSheet, View } from 'react-native';
import { useDyteSelector } from '@dytesdk/react-native-core';
import DyteClient from '@dytesdk/web-core';
import { Dropdown } from 'react-native-element-dropdown';
import { States } from '../types/props';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import DyteText from './DyteText';
import PeerView from '../PeerView';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  iconPack = defaultIconPack,
  size = 'sm',
  states,
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  states?: States;
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  states = states ?? storeStates;
  const [devicesVideo, setVideoDevices] = useState([]);
  const { self } = useDyteSelector((m) => m);
  useEffect(() => {
    const load = async () => {
      const video = await meeting.self.getVideoDevices();
      const _devicesVideo = [];
      video.map((item) => {
        const name =
          item.facing[0].toUpperCase() +
          item.facing.substring(1, item.facing.length);
        // Label and Value needed for Dropdown component
        if (name !== 'Environment')
          _devicesVideo.push({
            label: name,
            value: _devicesVideo.length + 1,
            deviceId: item.deviceId,
            kind: item.kind,
          });
        else
          _devicesVideo.push({
            label: 'Rear',
            value: _devicesVideo.length + 1,
            deviceId: item.deviceId,
            kind: item.kind,
          });
      });
      setVideoDevices(_devicesVideo);
    };
    load();
  }, [meeting, self]);
  if (self.mediaPermissions.video !== 'ACCEPTED') return null;
  const currentDeviceIndex = devicesVideo
    .map((device, index) => {
      const facing =
        self.mediaPermissions.video === 'ACCEPTED'
          ? self.getCurrentDevices().video.facing
          : null;
      switch (facing) {
        case 'front':
          if (device.label.toString() === 'Front') return index + 1;
          break;
        case 'environment':
          if (device.label.toString() === 'Rear') return index + 1;
          break;
      }
      return -1;
    })
    .find((val) => val !== -1);
  const selectVideo = (_device) => {
    devicesVideo.forEach(async (data) => {
      if (data.label === _device.label) {
        await meeting.self.setDevice(data);
        return;
      }
    });
  };
  const styles = StyleSheet.create({
    dropdown: {
      backgroundColor: colors.background[800],
      marginLeft: 0,
      marginRight: 10,
      alignItems: 'center',
      borderRadius: 5,
      padding: 8,
    },
    dropdownContainer: {
      borderColor: colors.background[800],
      borderWidth: 2,
    },
    dropdownText: {
      color: colors.text,
      marginLeft: 10,
    },
    renderContainer: {
      backgroundColor: colors.background[800],
      padding: 10,
    },
    renderText: {
      color: colors.text,
    },
    videoWrapper: {
      marginHorizontal: 10,
    },
    videoContainer: {
      alignItems: 'center',
      marginBottom: '5%',
      //borderWidth: meeting.self.videoEnabled ? 0 : 0.6,
      borderColor: colors.text,
    },
    videoOptionText: {
      marginBottom: 10,
      color: colors.text,
    },
  });
  const renderItem = (item) => {
    return (
      <View style={styles.renderContainer}>
        <DyteText style={styles.renderText}>{item.label}</DyteText>
      </View>
    );
  };
  const videoOptions = () => {
    return (
      <View style={styles.videoWrapper}>
        <View />
        <View style={styles.videoContainer}>
          {/* ToDo: Fix use of width here */}
          <PeerView participant={self} width={300} />
        </View>
        <DyteText size="sm" fontWeight="800" style={styles.videoOptionText}>
          Camera
        </DyteText>
        <Dropdown
          style={styles.dropdown}
          containerStyle={styles.dropdownContainer}
          selectedTextStyle={styles.dropdownText}
          renderItem={renderItem}
          data={devicesVideo}
          labelField={'label'}
          valueField={'value'}
          value={currentDeviceIndex}
          onChange={selectVideo}
        />
      </View>
    );
  };
  return videoOptions();
}
